import { Component, computed, input } from '@angular/core';
import { NgComponentOutlet, NgTemplateOutlet, NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonBase } from '../../../directives/button-base';
import { variantClass } from '../../../../core/utils/class';

@Component({
  selector: 'icon-button',
  imports: [NgComponentOutlet, RouterModule, NgTemplateOutlet, NgClass],
  templateUrl: './icon-button.html',
  styleUrl: './icon-button.scss',
})
export class IconButton extends ButtonBase {
  private readonly badgeLimit = 9;

  variant = input<'default' | 'color'>('default');
  badgeCount = input<number | null>(null);

  prefix = 'icon-button';

  buttonClass = computed(() => {
    const variant = this.variant();
    return {
      [variantClass(this.prefix, 'colored')]: variant === 'color',
    };
  });

  displayBadgeCount = computed(() => {
    const n = this.badgeCount();
    if (n === null || n <= 0) {
      return null;
    }
    if (n > this.badgeLimit) return `+${this.badgeLimit}`;
    return n.toString();
  });
}
